import { addStyles } from 'ethcss'
import 'blocks.app/loader/loader.css'
import { colors, IStyles, mediaCSS } from '../../../theme'

const uploadLogsStyles: IStyles = {
    modal: {
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.7)',
    },
    modalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        borderRadius: 20,
        padding: 34,
        maxWidth: 370,
        border: '1px solid black',
        display: 'flex',
        gap: 20,
        flexDirection: 'column',
        [mediaCSS.tab]: {
            width: '90%',
        },
    },
    title: {
        fontSize: 22,
        fontWeight: 600
    },
    subLabel: {
        fontSize: 12,
        color: colors.offline
    },
    hint: {
        fontSize: 12,
        color: colors.grey
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 12
    }
}

addStyles(uploadLogsStyles)
export default uploadLogsStyles
